import Service from '@/service/index.js';
import LandInfo from '../land-info/land-info.vue'; // 耕地类型地块信息
import ProjectType2 from '../project-type-2/project-type-2.vue'; // 林地
import ProjectType3 from '../project-type-3/project-type-3.vue'; // 水面
import ProjectType4 from '../project-type-4/project-type-4.vue'; // 四荒
import ProjectType6 from '../project-type-6/project-type-6.vue'; // 房屋
import ProjectType7 from '../project-type-7/project-type-7.vue'; // 设备设施

export default {
  components: {
    LandInfo,
    ProjectType2,
    ProjectType3,
    ProjectType4,
    ProjectType6,
    ProjectType7
  },
  props: ['item', 'index', 'transferType', 'projectSubType', 'needtoShow'],
  data() {
    return {
      bidGeneralSituationArr: [],
      isSubletArr: []
    };
  },

  created() {
    Service.getSelectList('BID_GENERAL_SITUATION').then(({ code, data }) => {
      if (code === '0') {
        this.bidGeneralSituationArr = data;
      }
    });
    // 交易方式
    Service.getSelectList('MASSIF_TRADE_TYPE').then(({ code, data }) => {
      if (code === '0') {
        this.isSubletArr = data;
      }
    });
  },
  methods: {
    landItemUnit(type) {
      if(Number(type) === 5)
        return '平方米';
      if(Number(type) === 6)
        return '台（套）';
      return '亩';
    },
    landItemTimeText(type) {
      if(Number(type) === 5 || Number(type) === 6)
        return '出租期限';
      return '发包期限';
    },
    // 是否展示发包时间
    isShowTime (type, isSublet) {
      let flag = false;
      if (type !== 7) {
        flag = true;
      }
      if (Number(type) === 5 || Number(type) === 6) {
        if(Number(isSublet) === 2) {
          flag = false;
        } else {
          flag = true;
        }
      }
      return flag;
    }
  }
};
